// extracted by mini-css-extract-plugin
export default {"item":"Odds_item__5iQM4","color":"Odds_color__w-dDK","fadeInBottom":"Odds_fadeInBottom__6Cmd2"};